import clsx from "clsx";
import { Chat } from "../../../models";
import { useHistory } from "react-router";
import routes from "../../../constants/routes";
import { useStore } from "../../../stores";

export default function CommentReference({
  payload,
}: {
  payload: {
    commentId: string;
    commenterId: string;
    commentText: string;
    commentMessageId: string;
    chat: Chat;
  };
}) {
  const history = useHistory();
  const { routeTo } = useStore("bots");
  const repliedIsFromUser = true;
  const isFromUser = true;

  return (
    <div
      className={clsx("mb-2 px-3 py-2 is-relative", {
        "has-background-white-ter": isFromUser,
        "has-background-light": !isFromUser,
      })}
      onClick={() => {
        history.push(
          routeTo(routes.chats).replace(
            ":chatId?",
            `${payload.chat.id as any}`
          ) + `?tab=all&selectedMessageId=${payload.commentMessageId}`
        );
      }}
      style={{
        borderLeft: `3px solid ${repliedIsFromUser ? "#2a79ef" : "#667781"}`,
        borderRadius: "8px",
        backgroundColor: isFromUser
          ? "rgba(0, 0, 0, 0.05)"
          : "rgba(255, 255, 255, 0.1)",
        cursor: "pointer",
      }}
    >
      {/* Replied to indicator line */}
      <div
        className="is-size-7 has-text-weight-semibold mb-1"
        style={{
          color: repliedIsFromUser ? "#2a79ef" : "#667781",
          fontSize: "0.75rem",
        }}
      >
        You have responeded on this comment
      </div>

      {/* Replied message content */}
      <div
        className="is-size-7"
        style={{
          color: isFromUser ? "#4a5568" : "rgba(3, 3, 3, 0.8)",
          fontSize: "0.8rem",
          lineHeight: "1.2",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {payload.commentText}
      </div>
    </div>
  );
}
